import Modal from '../../../utils/modal';
import NormalButton from '../../Buttons/NormalButton';
import RadioGroup from 'src/components/Forms/RadioGroup';
import React, { useState } from 'react';
import useStyles from './style';
import { CircularProgress } from '@mui/material';
import { isCypress } from '../../../utils/useCypress';
import { setConfirmOptionsModal } from '../../../store/actions/modals.actions';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux-hooks';
import { useStates } from 'src/utils/useState';
import { useTranslation } from 'react-i18next';

const ConfirmOptionsModal: React.FunctionComponent = () => {

  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const modalsData = useAppSelector((state: any) => state.modals);

  const [isLoading, setIsLoading] = useState(false);

  const title = modalsData.confirmOptionsModal.title;
  const content = modalsData.confirmOptionsModal.content;
  const options = modalsData.confirmOptionsModal.options ? modalsData.confirmOptionsModal.options.filter((item: any) => item !== null) : [];
  const isAutoClose = modalsData.confirmOptionsModal.autoClose;
  const onAccept = modalsData.confirmOptionsModal.onAccept;
  const onDecline = modalsData.confirmOptionsModal.onDecline;

  const option = options.filter((item: any) => item.selected).length === 1 ? options.find((item: any) => item.selected).value : options[0].value;

  const [state, setState] = useStates({
    option: option,
  });
  
  const onCloseModal = (_: any, reason?: any) => {
    if(reason && reason === "backdropClick") {
      return;
    }    
    const settings = {
      isOpen: false,
      title: null,
      content: null,
      options: null,
      autoClose: true,
      onAccept: null,
      onDecline: null,
    };
    dispatch(setConfirmOptionsModal(settings));
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    onCloseModal(e, "user");
  };

  const handleOption = (e: any) => {
    setState("option", e.target.value);
  };

  const handleOnAccept = (e: any) => {
    setIsLoading(true);
    if(onAccept) {
      onAccept(e, state.option, onCloseModal);
    }
    if(isAutoClose) {
      handleClose(e);
    }
  };

  const handleOnDecline = (e: any) => {
    setIsLoading(true);
    if(onDecline) {
     onDecline(e);
    }
    handleClose(e);
  };
  
  return (
    <Modal 
      open={true}
      onClose={onCloseModal}
      disableEscapeKeyDown={isLoading}
    >
      <div className={classes.root} data-cy={isCypress() ? "confirmModal" : null}>
        {
          isLoading ? (
            <div className={classes.loadingWrapper}>
              <div className={classes.spinner}>
                <CircularProgress/>
              </div>
            </div>
          ) : null
        }
        <div className={classes.header}>
          <div className={classes.wrapper}>
            <p>{title}</p>
          </div>
        </div>
        <div className={classes.body}>
          <p className={classes.text}>
            {content}
          </p>
          <RadioGroup className={classes.radioGroup} items={options} value={state.option} onChange={handleOption}/>
        </div>
        <div className={classes.footer}>
          <NormalButton buttonType="secondary" onClick={handleOnDecline} data-cy={isCypress() ? "declineButton" : null} disabled={isLoading}>
            {t("cancel")}
          </NormalButton>
          <NormalButton buttonType="primary" onClick={handleOnAccept} data-cy={isCypress() ? "acceptButton" : null} disabled={isLoading}>
            {t("continue")}
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmOptionsModal;